import { Theme } from "@amx/ux-twoui-theming";
import { Alignment, IStackStyles } from "@fluentui/react";
import { TextAlignment } from "../../../../styles/fonts";
import { ChoiceGroupHeight } from "../../shared/props";
import { getChoiceGroupButtonStyles } from "../../shared/styles";

export const getSelectButtonStyles = (
    theme: Theme,
    isMobile: boolean,
    height: ChoiceGroupHeight = "auto",
    textAlignment: TextAlignment,
    disabled?: boolean,
    selected?: boolean): IStackStyles => {

    return {
        root: {
            ...getChoiceGroupButtonStyles(theme, isMobile, height, textAlignment, disabled, selected)
        }
    };
};

export const getSelectButtonLineItemsHorizontalAlign = (textAlignment: TextAlignment): Alignment => {
    switch (textAlignment) {
        case "left":
            return "start";
        case "center":
            return "center";
        case "right":
            return "end";
    }
};
